import React from 'react';
import { motion } from 'motion/react';

export default function TermsOfService() {
  return (
    <div className="pt-40 pb-24 min-h-screen bg-black text-white px-4 sm:px-8 lg:px-16 relative overflow-hidden">
      {/* Background Gradients */}
      <div className="absolute inset-0 w-full h-full z-0 pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-b from-black via-black/90 to-black pointer-events-none" />
      </div>

      {/* Background glow */}
      <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] bg-blue-500/5 rounded-full blur-[120px] pointer-events-none z-0" />
      <div className="absolute bottom-1/4 right-1/4 w-[500px] h-[500px] bg-green-500/5 rounded-full blur-[120px] pointer-events-none z-0" />

      <div className="max-w-4xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-16"
        >
          <div className="liquid-glass rounded-full px-4 py-1.5 inline-block mb-6">
            <span className="text-sm font-medium text-white font-body tracking-wide">
              Legal
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl font-heading italic tracking-tight leading-[0.9] mb-6">
            Terms of Service
          </h1>
          <p className="text-white/60 font-body font-light text-lg max-w-2xl leading-relaxed">
            Last Updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}
          </p>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="liquid-glass rounded-[2rem] p-8 md:p-12 border border-white/10 shadow-[0_20px_50px_rgba(0,0,0,0.5)] prose prose-invert prose-sm sm:prose-base max-w-none font-body font-light leading-relaxed text-white/80"
        >
          <div className="space-y-10">
            <section>
              <h2 className="text-2xl font-heading italic text-white mb-4">1. Acceptance of Terms</h2>
              <p>By accessing this website, you agree to comply with these Terms of Service.</p>
            </section>

            <section>
              <h2 className="text-2xl font-heading italic text-white mb-4">2. Services</h2>
              <p>ESYAI LTD provides AI, technology, or consultancy-related services (as described on the website).</p>
            </section>

            <section>
              <h2 className="text-2xl font-heading italic text-white mb-4">3. Use of Website</h2>
              <p>You agree not to:</p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Use the site for unlawful purposes</li>
                <li>Attempt to hack or disrupt services</li>
                <li>Copy or reproduce content without permission</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-heading italic text-white mb-4">4. Intellectual Property</h2>
              <p>All content on this website (text, logos, graphics) is owned by ESYAI LTD unless otherwise stated.</p>
            </section>

            <section>
              <h2 className="text-2xl font-heading italic text-white mb-4">5. Disclaimer</h2>
              <p>Our website and services are provided “as is” without warranties of any kind.</p>
            </section>

            <section>
              <h2 className="text-2xl font-heading italic text-white mb-4">6. Limitation of Liability</h2>
              <p>We are not liable for:</p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Any indirect or consequential damages</li>
                <li>Loss of data, profits, or business</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-heading italic text-white mb-4">7. Third-Party Services</h2>
              <p>We may link to or integrate third-party services. We are not responsible for their content or policies.</p>
            </section>

            <section>
              <h2 className="text-2xl font-heading italic text-white mb-4">8. User Content</h2>
              <p>If you submit content:</p>
              <ul className="list-disc pl-5 space-y-2">
                <li>You grant us a non-exclusive right to use it</li>
                <li>You confirm it does not violate any laws</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-heading italic text-white mb-4">9. Termination</h2>
              <p>We reserve the right to suspend or terminate access if these terms are violated.</p>
            </section>

            <section>
              <h2 className="text-2xl font-heading italic text-white mb-4">10. Governing Law</h2>
              <p>These terms are governed by the laws of England and Wales.</p>
            </section>

            <section>
              <h2 className="text-2xl font-heading italic text-white mb-4">11. Changes to Terms</h2>
              <p>We may update these terms at any time. Continued use means acceptance of updates.</p>
            </section>

            <section>
              <h2 className="text-2xl font-heading italic text-white mb-4">12. Contact</h2>
              <p>For questions, contact:</p>
              <p>Email: <a href="mailto:info@esyai.co.uk" className="text-white underline underline-offset-4 decoration-white/20 hover:decoration-white transition-all">info@esyai.co.uk</a></p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
